import { Component } from "react"

/* Components */
import { Layout } from "../components"

/* Sweet alert */
import Swal from "sweetalert2"

/* Socket IO */
import io from "socket.io-client"

/* Constants */
import { env } from "../constants"

/* REST API */
import { dashboard } from "../api/Dashboard"

/* Widgets */
import { Device, Stream, CreateUser } from "../widgets"


/* Page Dashboard */
class Dashboard extends Component {

    constructor() {
        super()

        this.state = {
            status: "loading",
            data: [],
            connection: "loading"
        }

        this.socket = null
        this.timing = null
    }

    componentDidMount = () => {

        /* Socket Connect */
        this.connect()

        /* Register Socket Events */
        this.socketEvents()

        /* Load */
        this.load()
    }

    /* Load action */
    load = (reload = false) => {

        /* Check Reload */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* Send to REST API */
        dashboard().then(response => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data })
            }
            else {
                this.setState({ status: "error", data: [] })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [] })
        })

    }

    /* Connect */
    connect = () => {

        /* Fields */
        const token = localStorage.getItem("token")

        /* Start Connect */
        this.socket = io(`${env.socketpoint}`, { auth: { token: `${token}`, type: "admin" } })
    }

    /* Socket Events */
    socketEvents = () => {

        /* Check Socket */
        if (this.socket) {

            /* Clear Timing */
            if (this.timing) {
                clearTimeout(this.timing)
                this.timing = null
            }

            /* On Connect */
            this.socket.on("connect", () => {
                this.setState({ connection: "connected" })
            })

            /* On Connect Error */
            this.socket.on("connect_error", () => {
                this.setState({ connection: "disconnected" })
            })

            /* On Disconnect */
            this.socket.on("disconnect", () => {
                this.setState({ connection: "disconnected" })
            })

            /* On New Tab */
            this.socket.on("new-admin-connection", () => {
                this.setState({ connection: "new-tab" })
                this._stream.close()
                this._create.close()
            })

            /* Connection Status */
            this.socket.on("dashboard-connection-update", ({ token, status }) => {

                /* Fields */
                const { data } = this.state

                /* Get Index */
                const index = data.findIndex(e => e.token === token)

                /* Check Index */
                if (index > -1) {
                    data[index].connection = status
                    this.setState({ data })
                }

            })


            /* Stream Status */
            this.socket.on("dashboard-stream-update", ({ token, status }) => {

                /* Fields */
                const { data } = this.state

                /* Get Index */
                const index = data.findIndex(e => e.token === token)

                /* Check Index */
                if (index > -1) {
                    data[index].stream = status
                    this.setState({ data })
                }

            })


        }
        else {

            /* Reconnect after 2 seconds */
            this.timing = setTimeout(() => {
                clearTimeout(this.timing)
                this.timing = null
                this.socketEvents()
            }, 2000)

        }

    }


    /* Reconnection */
    reconnection = () => {

        /* Start Loading */
        this.setState({ connection: "loading" })

        /* Reconnection */
        const timer = setTimeout(() => {

            /* Reconnect */
            this.connect()

            /* Restart Socket events */
            this.socketEvents()

            /* Clear Timing */
            clearTimeout(timer)

        }, 2000)
    }


    /* Logout */
    logout = () => {

        /* Fields */
        const { setToken } = this.props

        /* Swal Container */
        Swal.fire({
            title: 'Выйти?',
            text: "Вы действительно хотите выйти?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#f44336',
            reverseButtons: true,
            confirmButtonText: 'Выйти',
            cancelButtonText: 'Отмена'
        }).then(result => {
            if (result.isConfirmed) {
                setToken(null)
                localStorage.removeItem("token")
                localStorage.removeItem("user")
            }
        })
    }

    /* Draw Content */
    _content = () => {

        /* Fields */
        const { status, data, connection } = this.state

        /* Layout */
        if (status !== "ok") {
            return <Layout status={status} reload={() => this.load(true)} />
        }

        /* Disconnected */
        if (connection === "disconnected") {
            return <Layout status="socket" connection={connection} reload={() => this.reconnection()} />
        }

        /* New Tab */
        if (connection === "new-tab") {
            return <Layout status="socket" connection={connection} refresh={() => window.location.reload()} />
        }

        /* Empty */
        if (data.length === 0) {
            return <Layout status="empty" type="user" add={() => this._create.open()} />
        }

        return (
            <div className="container">
                {data.map((item, index) => <Device data={item} open={token => this._stream.open(token)} key={`${index}`} />)}
                <div onClick={() => this._create.open()} className="create-button">
                    <img src="/images/plus.png" alt="Plus" />
                    <span>Добавить пользователя</span>
                </div>
            </div>
        )
    }

    /* Draw Header */
    _header = () => {

        /* Fields */
        const json = localStorage.getItem("user")
        const user = json ? JSON.parse(json) : null

        return (
            <div className="dashboard-header">

                {/* Logo */}
                <div className="dashboard-header-logo">
                    <img src="/images/logo.png" alt="Logo" />
                    <div className="dashboard-header-logo-container">
                        <h1>FLINT</h1>
                        <span>MANAGER</span>
                    </div>
                </div>

                {/* Profile */}
                <div onClick={() => this.logout()} className="dashboard-header-profile">

                    <img src="/images/profile-user.png" alt="Profile" />

                    <div className="dashboard-header-user-text">
                        <div className="dashboard-header-user-name">{user && user.name}</div>
                        <div className="dashboard-header-user-role">Менеджер</div>
                    </div>

                    <div className="dashboard-header-user-logout">
                        <img src="/images/logout.png" alt="Logout" />
                    </div>

                </div>

            </div>
        )
    }

    render = () => {

        return (
            <div className="app">

                {/* Draw Header */}
                {this._header()}

                {/* Draw Content */}
                {this._content()}

                {/* Draw Stream */}
                <Stream ref={ref => this._stream = ref} socket={this.socket} reload={() => this.load(true)} />

                {/* Draw Create User */}
                <CreateUser ref={ref => this._create = ref} reload={() => this.load(true)} />

            </div>
        )
    }

}

export default Dashboard